var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27377",
    "data-name": "Rectangle 27377",
    width: 34,
    height: 36,
    transform: "translate(0 -2)",
    fill: "#5c6d7e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-teams"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teams",
    clipPath: "url(#clip-teams)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "team_3",
    transform: "translate(3 2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9919",
    "data-name": "Group 9919",
    transform: "translate(0 -0.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9916",
    "data-name": "Group 9916",
    transform: "translate(0 10.253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard_3",
    "data-name": "Artboard 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21188",
    "data-name": "Path 21188",
    d: "M11.727,8.749A8.271,8.271,0,0,0,9.39,7.754a4.006,4.006,0,1,0-3.161,0,8.381,8.381,0,0,0-2.338.995C1.2,10.394,0,12.985,0,17.177a.7.7,0,1,0,1.4,0c0-4.65,1.626-6.265,3.215-7.233a5.585,5.585,0,0,1,6.381,0,.7.7,0,0,0,.728-1.195ZM5.458,5.238A2.623,2.623,0,1,1,7.795,6.68,2.6,2.6,0,0,1,5.458,5.238Z",
    transform: "translate(0 -0.025)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21189",
    "data-name": "Path 21189",
    d: "M86.3,8.779a8.281,8.281,0,0,0-2.337-1,4.022,4.022,0,1,0-3.154,0,8.231,8.231,0,0,0-2.337,1A.7.7,0,0,0,79.2,9.974a5.58,5.58,0,0,1,6.379,0c1.592.973,3.218,2.583,3.218,7.233a.7.7,0,0,0,1.4,0C90.19,13.015,88.988,10.419,86.3,8.779ZM80.062,5.268a2.585,2.585,0,0,1-.293-1.192,2.657,2.657,0,1,1,.293,1.192Z",
    transform: "translate(-56.851 -0.055)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21190",
    "data-name": "Path 21190",
    d: "M45.531,8.75a8.288,8.288,0,0,0-2.337-1,4.006,4.006,0,1,0-3.158,0,8.259,8.259,0,0,0-2.337,1c-2.7,1.639-3.89,4.236-3.89,8.428a.7.7,0,0,0,1.4,0c0-4.65,1.628-6.265,3.218-7.233a5.585,5.585,0,0,1,6.381,0c1.589.973,3.218,2.583,3.218,7.233a.7.7,0,1,0,1.4,0C49.42,12.985,48.221,10.388,45.531,8.75ZM39.262,5.238A2.623,2.623,0,1,1,41.6,6.68,2.6,2.6,0,0,1,39.262,5.238Z",
    transform: "translate(-24.932 4.816)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_21191",
    "data-name": "Path 21191",
    d: "M201.191,138.937l1.6,3.247,3.588.513-2.6,2.531.613,3.573-3.207-1.687-3.207,1.687.613-3.573-2.6-2.519,3.588-.513Z",
    transform: "translate(-184.517 -138.937)",
    fill: "#5c6d7e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.780499fea748487b5045b819e212b909.svg";
export { ForwardRef as ReactComponent };